import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'components/atoms/baseButton';
import PlusIcon from 'components/atoms/icons/plus.svg?react';

import s from './styles.module.scss';

interface IProps {
  handleAddCampaign: () => void;
}

const SmsCampaignsDashboardHeader: React.FC<IProps> = ({
  handleAddCampaign,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <h1 className={s.title}>{t('labels.smsCampaignsDashboard')}</h1>
      <div className={s.controls}>
        <BaseButton
          label={t('smsCampaign.addNewCampaign')}
          onClick={handleAddCampaign}
          icon={<PlusIcon />}
        />
      </div>
    </div>
  );
};

export default SmsCampaignsDashboardHeader;
